import { gsap } from 'gsap'

const cardSliders = document.querySelectorAll('[data-card-slider]')

Array.from(cardSliders).forEach((elCardSlider) => {
    const slides = elCardSlider.querySelectorAll('[data-slide]')
    const elNext = elCardSlider.querySelector('[data-control-next]')
    const elPrev = elCardSlider.querySelector('[data-control-prev]')

    let currentSlide = 1
    const totalSlides = slides.length / 5

    const handleSlideChange = (slide) => {
        slides.forEach((slide) => {
            slide.removeAttribute('data-active')
            slide.setAttribute('aria-hidden', 'true')
        })

        const targetSlides = elCardSlider.querySelectorAll(
            `[data-slide="${slide}"]`
        )

        targetSlides.forEach((targetSlide) => {
            targetSlide.setAttribute('data-active', 'true')
            targetSlide.setAttribute('aria-hidden', 'false')
        })
    }

    elNext?.addEventListener('click', () => {
        let nextSlide = ++currentSlide

        if (nextSlide > totalSlides) {
            nextSlide = 1
            currentSlide = 1
        }

        handleSlideChange(nextSlide)
    })

    elPrev?.addEventListener('click', () => {
        let nextSlide = --currentSlide

        if (nextSlide === 0) {
            nextSlide = totalSlides
            currentSlide = totalSlides
        }

        handleSlideChange(nextSlide)
    })

    // Animate nav buttons
    elNext?.addEventListener('mouseenter', function () {
        const tl = gsap.timeline({
            defaults: {
                duration: 0.25,
                ease: 'power1.inOut',
            },
        })
        tl.to(this.querySelector('svg'), {
            x: '0.3rem',
        })
        tl.to(this.querySelector('svg'), {
            x: '0',
        })
    })

    elPrev?.addEventListener('mouseenter', function () {
        const tl = gsap.timeline({
            defaults: {
                duration: 0.25,
                ease: 'power1.inOut',
            },
        })
        tl.to(this.querySelector('svg'), {
            x: '-0.3rem',
        })
        tl.to(this.querySelector('svg'), {
            x: '0',
        })
    })
})
